import React from 'react'
import NumberInput from '../../common/NumberInput'

export interface IProportionSelectorProps {
    value: number;
    onProportionChanged: (val: number) => void;
    style?: any;
}

const ProportionSelector: React.FC<IProportionSelectorProps> = ({ value, onProportionChanged, style }) => {
  // return <NumberInput slotProps={{incrementButton: { hidden: true }, decrementButton: { hidden: true }, input: { style: { width: "100%", lineHeight: "16px", fontSize: "12px", textAlign: "right", fontFamily: "Montserrat", fontWeight: "500"}}, root: { style: { ...style, width: "36px", padding: 0, height: "auto", border: 0, fontSize: "12px", fontWeight: "500"}}}} endAdornment={"%"} max={100} min={0} value={value * 100} onClick={(e) => e.stopPropagation()} onChange={(e, val) => onProportionChanged(val ? val / 100 : 0)} />
  return <NumberInput max={100} min={0} placeholder='0' value={value * 100} onClick={(e) => e.stopPropagation()} onChange={(e, val) => onProportionChanged(val ? val / 100 : 0)} style={{ ...style, width: "45px", fontSize: "12px", textAlign: "right", padding: "0 6px 0 2px", borderRadius: "100px"}} smallFormat endAdornment='%' disableMask />
}

export default ProportionSelector